var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("span", { staticClass: "ml-1" }, [
    _c(
      "a",
      {
        attrs: { href: "#" },
        on: {
          click: function ($event) {
            return _vm.$emit("apply-filter", _vm.column, _vm.toggleSort)
          },
        },
      },
      [
        !_vm.selected
          ? _c("font-awesome-icon", {
              attrs: {
                icon: ["fas", "exchange-alt"],
                color: "lightgray",
                rotation: "90",
              },
            })
          : _c("font-awesome-icon", {
              attrs: { icon: ["fas", _vm.iconDisplayed], color: "black" },
            }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }